import { Injectable, WritableSignal, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SideBarService {
  isSideBarOpen: WritableSignal<boolean> = signal(false);

  openSideBar(): void {
    this.isSideBarOpen.set(true);
  }

  closeSideBar(): void {
    this.isSideBarOpen.set(false);
  }

  toggleSideBar(): void {
    this.isSideBarOpen.update((prev) => !prev);
  }
}
